import { AfterViewInit, Component, ElementRef, Inject, Input, NgZone, PLATFORM_ID, TransferState } from '@angular/core';

import {
  DxButtonComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';

@Component({
  selector: 'abc-button',
  standalone: true,
  template: '',
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost],
})
export class _AbcButtonComponent extends DxButtonComponent implements AfterViewInit {
  private tooltTip: AbcTooltipDirective;
  /**
   * If `toolTipContent` is  `null` or  `undifined` , the tooltip will use the outerText of the button.
   * If `toolTipContent` is provided , the tooltip will display this custom content.
   **/
  private _toolTipContent: string;
  @Input()
  set toolTipContent(value: string) {
    this._toolTipContent = value;
    this.setTooltipContent();
  }
  get toolTipContent(): string {
    return this._toolTipContent;
  }
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, optionHost, transferState, platformId);
    this.tooltTip = new AbcTooltipDirective(this.element);
    this.tooltTip.elementClassName = '.dx-button-content';
  }

  private setTooltipContent(): void {
    if (this.toolTipContent) {
      this.tooltTip.toolTipContentTemplate = this.toolTipContent;
    }
  }
}
